module.exports = __webpack_public_path__ + "media/images/gabe-f718dcb5db85161c773dbeb885035bbf.png";